import React, { useCallback, useEffect, useRef, useState } from "react";
import { createPortal } from "react-dom";
import PropTypes from "prop-types";

const useDomElement = (elementId) =>
  useRef(document.getElementById(elementId)).current;

export const PortalAsync = ({ parentId, elementId, Component, ...props }) => {
  const [domEl, setDomEl] = useState(null);
  const widgetEl = useDomElement(parentId);
  let observer = useRef(null);

  const updatePortal = useCallback(() => {
    const dynamicPortal = document.getElementById(elementId);
    setDomEl(dynamicPortal);
  }, [elementId]);

  useEffect(() => {
    if (widgetEl && !observer.current) {
      observer.current = new MutationObserver(updatePortal);
      observer.current.observe(widgetEl, { childList: true, subtree: true });
    }
    if (document.getElementById(elementId)) {
      updatePortal();
    }
  }, [elementId, widgetEl, updatePortal]);

  useEffect(
    () => () => {
      if (observer.current) {
        observer.current.disconnect();
      }
    },
    [],
  );

  return domEl ? createPortal(<Component {...props} />, domEl) : null;
};

PortalAsync.propTypes = {
  parentId: PropTypes.string.isRequired,
  elementId: PropTypes.string.isRequired,
  Component: PropTypes.func.isRequired,
};
